var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"ml-3 text-uppercase font-weight-bold "},[_vm._v("Assessments")]),_vm._v(" "),_c('div',{staticClass:"widget p-3"},[_c('polar-area-chart',{attrs:{"height":200,"width":280,"data":_vm.polarAreaChart(),"options":{
                legend: { display: false },
                position: 'top',
                layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
                responsive: true,
                maintainAspectRatio: false,
                scale: {
                    gridLines: {
                        color: '#ffffff',
                        drawOnChartArea: true,
                    },
                    ticks: {
                        display: false,
                        min: 0,
                        max: 6,
                        fontColor: 'transparent',
                    },
                },
            }}},[_vm._v(">")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }